import React, { useState, useEffect } from "react";
import { useLoader } from "../../../context/LoaderProvider.jsx";

const Tablereservationcode = () => {
    const [bookings, setBookings] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const { showLoader, hideLoader } = useLoader();
    // Modal and Edit State
    const [showModal, setShowModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [editRemarks, setEditRemarks] = useState('');
    const [editPaymentStatus, setEditPaymentStatus] = useState('');

    // Filter State
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');

    const paymentStatusOptions = ["Paid", "Pending", "Failed", "Refunded", "Not Applicable"];
    const vendorId = localStorage.getItem('vendorId');
    const authToken = localStorage.getItem('authToken');

    // --- NEW: Define the style object for the table header ---
    const headerStyle = {
        backgroundColor: '#b15cd6',
        color: 'white',
        borderColor: '#9a49bb', // This makes the borders match the background
    };

    useEffect(() => {
        if (!vendorId || !authToken) {
            console.error("Vendor ID or auth token not found in localStorage");
            setError("Authentication details are missing. Please log in again.");
            setIsLoading(false);
            return;
        }
        showLoader();
        setIsLoading(true);
        setError(null);
        fetch(`https://backend.maamaas.com/food/api/seatingdetails/isBooked/user/${vendorId}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${authToken}`,
                "Content-Type": "application/json",
            }
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error(`Failed to fetch booking data. Status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                const mapped = Array.isArray(data) ? data : [];
                setBookings(mapped.map(item => ({
                    id: item.id,
                    tableId: item.seating?.code || 'N/A',
                    Floor: item.seating?.name || 'N/A',
                    user: item.guestName || 'N/A',
                    date: item.bookingDate || '',
                    time: item.startTime || '',
                    status: item.seatingStatus || 'N/A',
                    Capacity: item.seating?.capacity || 'N/A',
                    phoneNumber: item.phoneNumber || 'N/A',
                    email: item.email || 'N/A',
                    remarks: item.description || '',
                    paymentStatus: item.paymentStatus || 'Not Applicable',
                    durationMinutes: item.durationMinutes || 'N/A'
                })));
            })
            .catch(err => {
                console.error("Error fetching bookings:", err.message);
                setError(err.message);
            })
            .finally(() => {
                setIsLoading(false);
                hideLoader();
            });
    }, [vendorId, authToken]);

    const uniqueFloors = ['', ...new Set(bookings.map(booking => booking.Floor).filter(Boolean))];

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBooking(null);
        setEditRemarks('');
        setEditPaymentStatus('');
    };

    const handleSaveDetails = async () => {
        if (!selectedBooking) return;

        const payload = {
            description: editRemarks,
            paymentStatus: editPaymentStatus
        };

        try {
            const response = await fetch(`https://backend.maamaas.com/food/api/seatingdetails/vendor/seating-details/${selectedBooking.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to save details: ${errorText}`);
            }

            setBookings(prevBookings =>
                prevBookings.map(booking =>
                    booking.id === selectedBooking.id
                        ? { ...booking, remarks: editRemarks, paymentStatus: editPaymentStatus }
                        : booking
                )
            );
            alert("Details updated successfully!");
            handleCloseModal();

        } catch (err) {
            console.error("Error saving details:", err);
            alert(`Error: ${err.message}`);
        }
    };

    const formatDisplayDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            timeZone: 'UTC'
        });
    };

    const formatDisplayTime = (timeString) => {
        if (!timeString) return 'N/A';
        const parts = timeString.split(':');
        if (parts.length < 2) return 'N/A';
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        if (isNaN(hours) || isNaN(minutes)) return 'N/A';
        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit', minute: '2-digit', hour12: true
        });
    };

    const filteredBookings = bookings.filter(booking => {
        if (!booking.status || booking.status === 'Available' || booking.status === 'vacant') return false;
        const bookingDate = booking.date || '';
        const dateMatch = selectedDate ? bookingDate === selectedDate : true;
        const floorMatch = selectedFloor ? booking.Floor === selectedFloor : true;
        return dateMatch && floorMatch;
    });

    if (isLoading) {
        return <div className="text-center p-5">Loading booking details...</div>;
    }

    if (error) {
        return <div className="alert alert-danger text-center m-3">Error: {error}</div>;
    }

    return (
        <div>
            <div className="profile-details-container" style={{ overflowY: 'auto' }}>


                <div style={{ maxHeight: '45vh', overflowY: 'auto' }}>
                    <table className="table table-bordered table-striped">
                        {/* Remove the className from thead, as it's handled by inline styles now */}
                        <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <tr>
                                <th style={headerStyle}>#</th>
                                <th style={headerStyle}>Guest Name</th>
                                <th style={headerStyle}>Phone</th>
                                <th style={headerStyle}>Date</th>
                                <th style={headerStyle}>Time</th>
                                <th style={headerStyle}>Duration</th>
                                <th style={headerStyle}>Floor</th>
                                <th style={headerStyle}>Table</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredBookings.length > 0 ? filteredBookings.map((booking, index) => (
                                <tr key={booking.id}>
                                    <th>{index + 1}</th>
                                    <td>{booking.user}</td>
                                    <td>{booking.phoneNumber}</td>
                                    <td>{formatDisplayDate(booking.date)}</td>
                                    <td>{formatDisplayTime(booking.time)}</td>
                                    <td>{booking.durationMinutes} min</td>
                                    <td>{booking.Floor}</td>
                                    <td>{booking.tableId}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="11" className="text-center p-4">No bookings found for the selected filters.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal for Viewing/Editing Details */}
            {showModal && selectedBooking && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Booking Details for {selectedBooking.user}</h5>
                                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Date:</strong> {formatDisplayDate(selectedBooking.date)}</p>
                                <p><strong>Time:</strong> {formatDisplayTime(selectedBooking.time)}</p>
                                <p><strong>Table:</strong> {selectedBooking.tableId} ({selectedBooking.Floor})</p>
                                <hr />
                                <div className="mb-3">
                                    <label htmlFor="editRemarks" className="form-label">Remarks/Description</label>
                                    <textarea
                                        id="editRemarks"
                                        className="form-control"
                                        rows="3"
                                        value={editRemarks}
                                        onChange={(e) => setEditRemarks(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="editPaymentStatus" className="form-label">Payment Status</label>
                                    <select
                                        id="editPaymentStatus"
                                        className="form-select"
                                        value={editPaymentStatus}
                                        onChange={(e) => setEditPaymentStatus(e.target.value)}
                                    >
                                        {paymentStatusOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-success" onClick={handleSaveDetails}>Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Tablereservationcode;